/* eslint-disable prettier/prettier */
// src/utils/sanitizeProfilePayload.ts

import { UpdateProfileRequest } from '../types/user';

const normalizeArray = (val: any): string[] | undefined => {
	if (Array.isArray(val)) return val;

	if (typeof val === 'string') {
		try {
			const parsed = JSON.parse(val);
			return Array.isArray(parsed) ? parsed : undefined;
		} catch {
			return undefined;
		}
	}

	return undefined;
};

const sanitizeMetadata = (metadata: any) => {
	if (!metadata || typeof metadata !== 'object') return undefined;

	const cleaned = Object.entries(metadata).reduce(
		(acc, [key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				acc[key] = value;
			}
			return acc;
		},
		{} as Record<string, any>
	);

	return Object.keys(cleaned).length > 0 ? cleaned : undefined;
};

export const sanitizeProfilePayload = (
	data: UpdateProfileRequest
): UpdateProfileRequest => {
	return {
		...data,
		areasofinterest: normalizeArray(data.areasofinterest),
		coachingexperience: normalizeArray(data.coachingexperience),
		growthparameters: normalizeArray(data.growthparameters),
		metadata: sanitizeMetadata(data.metadata),
		skills: normalizeArray(data.skills),
		languages: normalizeArray(data.languages),
	};
};
